module.exports = __webpack_public_path__ + "static/media/advent.5dc2adaf.svg";